"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PsychrometricToolContainerComponent = PsychrometricToolContainerComponent;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Actions = __importStar(require("./actions"));
const Loaders = __importStar(require("@genesys/client-core/lib/loaders"));
const component_1 = require("./properties-selector-table/component");
const styled_components_1 = __importDefault(require("styled-components"));
const psychrometric_chart_1 = require("@genesys/psychrometric-chart");
const client_config_1 = require("../../../../client-config");
const FieldSet = (0, styled_components_1.default)(Elements.Field) `
  display: inline-block;
`;
const readOnlyProperties = ["enthalpy", "sensiblepower", "totalpower"];
function PsychrometricToolContainerComponent(props) {
    const pressureDef = pressureDefinition();
    const chartSettingsDef = chartSettingsDefinition();
    const showPower = property_1.PropertyValueSet.getInteger("showpower", props.chartState.chartSettings) !== 0;
    const airflowDef = airflowDefinition();
    const onAdd = () => props.dispatch(Actions.addRow());
    const onShowPowerChange = (pvs) => props.dispatch(Actions.setPropertiesShowPower(pvs));
    const onGenerate = () => {
        props.dispatch(Actions.setPropertiesGenerate());
        props.dispatch(Actions.setPropertiesShowChart());
    };
    const onPressureChange = (pvs) => props.dispatch(Actions.setPropertiesPressure(pvs));
    const onAirFlowChange = (pvs) => props.dispatch(Actions.setPropertiesAirFlow(pvs));
    return (React.createElement(Loaders.PleaseWaitOverlayLoaderIndicator, { active: props.showLoader },
        React.createElement(Elements.StandardContainer, null,
            React.createElement(Elements.FlexContainerRow, { center: false },
                React.createElement(Elements.InnerContainer, null,
                    React.createElement(Elements.H3, null, "Pressure"),
                    React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.chartState.pressure, productProperties: pressureDef, screenAmountProfileFieldGroup: "PsychrometricTool", onChange: (pvs) => onPressureChange(pvs), uniqueId: "psychrometric_tool_pressure" }),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    showPower ? (React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.airflow, productProperties: airflowDef, screenAmountProfileFieldGroup: "PsychrometricTool", onChange: (pvs) => onAirFlowChange(pvs), uniqueId: "psychrometric_tool_airflow" })) : null,
                    React.createElement(FieldSet, null,
                        React.createElement("legend", null, "Points"),
                        React.createElement(component_1.PropertiesSelectorTable, { screenAmountProfileFieldGroup: "PsychrometricTool", properyValueSets: props.chartState.rows, onChange: (pvs, rowIndex) => props.dispatch(Actions.setPropertiesRow(pvs, rowIndex)), onDelete: rowIndex => props.dispatch(Actions.deleteRow(rowIndex)), readOnlyProperties: readOnlyProperties, pressure: property_1.PropertyValueSet.getAmount("pressure", props.chartState.pressure), showPower: showPower }),
                        React.createElement("br", null),
                        React.createElement(Elements.StandardButton, { onClick: () => onAdd() }, "Add")),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement(Elements.FlexContainerRow, { center: false },
                        React.createElement(Elements.InnerContainer, null,
                            React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.chartState.chartSettings, productProperties: chartSettingsDef, screenAmountProfileFieldGroup: "PsychrometricTool", onChange: (pvs) => onShowPowerChange(pvs), uniqueId: "psychrometric_tool_showpower" }),
                            React.createElement(Elements.StandardButton, { onClick: () => onGenerate() }, "Generate")))),
                props.showChart ? (React.createElement(psychrometric_chart_1.PsychrometricChart, { url: client_config_1.config.getBackendFullUrl("/internal/GetPsychrometricChartSvg"), source: "custom", type: property_1.PropertyValueSet.getInteger("charttype", props.chartInputs.chartSettings) !== 0
                        ? "mollier"
                        : "psychrometric", si: property_1.PropertyValueSet.getInteger("ipsi", props.chartInputs.chartSettings) !== 0, points: props.chartInputs.rows.map(row => ({
                        temperature: property_1.PropertyValueSet.getAmount("temperature", row),
                        humidity: property_1.PropertyValueSet.getAmount("humidity", row)
                    })), pressure: property_1.PropertyValueSet.getAmount("pressure", props.chartInputs.pressure), binCases: [], binFields: [] })) : null))));
}
function pressureDefinition() {
    return [
        {
            sort_no: 1,
            name: "pressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
function airflowDefinition() {
    return [
        {
            sort_no: 1,
            name: "airflow",
            group: "",
            quantity: "MassFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
function chartSettingsDefinition() {
    return [
        {
            sort_no: 1,
            name: "showpower",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 0,
                    value: {
                        type: "integer",
                        value: 0
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 2,
            name: "charttype",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 0,
                    value: {
                        type: "integer",
                        value: 0
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 3,
            name: "ipsi",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 0,
                    value: {
                        type: "integer",
                        value: 0
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        }
    ];
}
//# sourceMappingURL=container-component.js.map